import {
  ApiGeneralDataResponse,
  ApiResponse,
  BotsGraphsDataResponse,
  BulkCancelSignalsRequest,
  FiltersRequest,
  getAccountsMainCoinsAvailableAmountRequest,
  getAccountsMainCoinsTotalAndAvailableAmountRequest,
  GetBotsDataRequest,
  GetBotsDataResponse,
  GetBotsGraphsDataRequest,
  GetPortfolioDataResponse,
  GetTradesDataResponse,
  GetTradesRequest,
  BulkChangeBotsStatusRequest,
  MainCoinsAvailableAmountResponseData,
  MainCoinsTotalAndAvailableAmountData,
  TradeData,
} from "@shared/types";

export interface BulkCancelProgressData {
  done?: number;
  failed?: number;
  inactive_market?: number;
  already_closed?: number;
  pending?: number;
}

export enum JobStatus {
  IN_PROGRESS = "in_progress",
  FINISHED = "finished",
  FAILED = "failed",
}

export interface GetJobResultResponse<T = any> extends ApiResponse<T> {
  status: JobStatus;
}

export interface JobsTypes {
  getBotsDataJob: {
    args: GetBotsDataRequest;
    rawResponse: GetJobResultResponse<ApiGeneralDataResponse<any[]>>;
    response: GetBotsDataResponse;
  };
  getBotsGraphsDataJob: {
    args: GetBotsGraphsDataRequest;
    rawResponse: GetJobResultResponse<
      ApiGeneralDataResponse<BotsGraphsDataResponse>
    >;
    response: ApiGeneralDataResponse<BotsGraphsDataResponse>;
  };
  getOpenTradesDataJob: {
    args: GetTradesRequest | void;
    rawResponse: GetJobResultResponse<GetTradesDataResponse>;
    response: ApiGeneralDataResponse<TradeData[]>;
  };
  getPortfolioDataJob: {
    args: { use_cache: boolean } | undefined;
    rawResponse: GetJobResultResponse<GetPortfolioDataResponse>;
    response: GetPortfolioDataResponse | undefined;
  };
  exportTradesJob: {
    args: {
      open_trades?: boolean;
      closed_trades?: boolean;
      filters?: FiltersRequest;
    };
    rawResponse: ApiResponse<{ path: string }>;
    response: string;
  };
  bulkCancelTradesJob: {
    args: { trade_ids: number[]; ratio: number };
    rawResponse: void;
    response: void;
  };
  bulkCancelSignalsJob: {
    args: BulkCancelSignalsRequest;
    rawResponse: void;
    response: void;
  };
  bulkChangeBotsStatusJob: {
    args: BulkChangeBotsStatusRequest;
    rawResponse: void;
    response: void;
  };
  exportBacktestTradesJob: {
    args: { backtesting_run_id: number };
    rawResponse: ApiResponse<{ path: string }>;
    response: string;
  };
  exportSignalsJob: {
    args: {
      open_signals?: boolean;
      closed_signals?: boolean;
      sub_group_id: number;
    };
    rawResponse: ApiResponse<{ path: string }>;
    response: string;
  };
  getAccountsMainCoinsAvailableAmountJob: {
    args: getAccountsMainCoinsAvailableAmountRequest;
    rawResponse: GetJobResultResponse<
      ApiGeneralDataResponse<MainCoinsAvailableAmountResponseData>
    >;
    response: ApiGeneralDataResponse<MainCoinsAvailableAmountResponseData>;
  };
  getAccountsMainCoinsTotalAndAvailableAmountJob: {
    args: getAccountsMainCoinsTotalAndAvailableAmountRequest;
    rawResponse: GetJobResultResponse<
      ApiGeneralDataResponse<MainCoinsTotalAndAvailableAmountData>
    >;
    response: ApiGeneralDataResponse<MainCoinsTotalAndAvailableAmountData>;
  };
  getJobResultsJob: {
    args: { job_id: string };
    rawResponse: any;
    response: any;
  };
}

export type JobEndpoint = keyof JobsTypes;
